import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import {
  Clock,
  Lock,
  Edit,
  X,
} from 'lucide-react';
import NeurologicalExamForm from '../NeurologicalExamForm';

const ExamTab = ({
  exams,
  selectedExam,
  setSelectedExam,
  examMode,
  setExamMode,
  patient,
  handleExamSubmit,
  handleEditExam,
  handleNewExam,
  handleOpenExam,
}) => {
  return (
    <div className="space-y-6">
      {exams.length > 0 && (
        <Card className="border-[#E5E4E0] bg-white" data-testid="exam-history">
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-base font-['Work_Sans'] flex items-center gap-2">
                <Clock className="w-4 h-4 text-[#4B6651]" />
                Exam History ({exams.length})
              </CardTitle>
              <Button
                size="sm"
                onClick={handleNewExam}
                className="bg-[#4B6651] hover:bg-[#3E5543] text-white text-xs"
                data-testid="new-exam-btn"
              >
                New Exam
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {exams.map((exam, idx) => {
                const isLocked = exam.is_locked;
                const isSelected = selectedExam?.id === exam.id;
                return (
                  <button
                    key={exam.id}
                    onClick={() => handleOpenExam(exam)}
                    className={`w-full p-3 rounded-lg text-left transition-colors flex items-center justify-between ${
                      isSelected
                        ? 'bg-[#4B6651]/10 border border-[#4B6651]'
                        : 'bg-[#F8F7F4] hover:bg-[#E5E4E0] border border-transparent'
                    }`}
                    data-testid={`exam-history-item-${exam.id}`}
                  >
                    <div>
                      <p className="font-medium text-sm text-[#2A2C2A]">
                        Exam #{idx + 1}
                        {exam.mental_status && exam.mental_status !== 'alert' && (
                          <span className="ml-2 text-xs text-[#C06144]">({exam.mental_status})</span>
                        )}
                      </p>
                      <p className="text-xs text-[#5C5F5C]">
                        {new Date(exam.created_at).toLocaleString()}
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      {isLocked ? (
                        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-[#5C5F5C]/10 text-[#5C5F5C] rounded text-xs">
                          <Lock className="w-3 h-3" />
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-[#4B6651]/10 text-[#4B6651] rounded text-xs">
                          <Edit className="w-3 h-3" />
                        </span>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}

      {(() => {
        if (selectedExam && examMode === 'view') {
          return (
            <NeurologicalExamForm
              onSubmit={() => {}}
              species={patient.species}
              initialData={selectedExam}
              readOnly={true}
            />
          );
        }
        if (selectedExam && examMode === 'edit') {
          return (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => { setSelectedExam(null); setExamMode('list'); }}
                  className="text-xs border-[#E5E4E0]"
                >
                  <X className="w-3 h-3 mr-1" /> Cancel
                </Button>
              </div>
              <NeurologicalExamForm
                onSubmit={handleEditExam}
                species={patient.species}
                initialData={selectedExam}
                isEdit={true}
              />
            </div>
          );
        }
        if (examMode === 'new') {
          return (
            <div>
              {exams.length > 0 && (
                <div className="flex items-center gap-2 mb-3">
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => setExamMode('list')}
                    className="text-xs border-[#E5E4E0]"
                  >
                    <X className="w-3 h-3 mr-1" /> Cancel
                  </Button>
                </div>
              )}
              <NeurologicalExamForm
                onSubmit={handleExamSubmit}
                species={patient.species}
              />
            </div>
          );
        }
        if (exams.length > 0) {
          return (
            <Card className="border-[#E5E4E0] bg-[#F8F7F4]">
              <CardContent className="py-8 text-center">
                <p className="text-[#5C5F5C] mb-2">Select an exam from the history above to view or edit.</p>
                <Button
                  onClick={() => setExamMode('new')}
                  className="bg-[#4B6651] hover:bg-[#3E5543] text-white"
                  data-testid="start-new-exam-btn"
                >
                  Or Start a New Exam
                </Button>
              </CardContent>
            </Card>
          );
        }
        return (
          <NeurologicalExamForm
            onSubmit={handleExamSubmit}
            species={patient.species}
          />
        );
      })()}
    </div>
  );
};

export default ExamTab;
